import React from "react";
import '../styles/App.css';
import { Link } from 'react-router-dom';
import RotatingGallery from "../components/RotatingGallery";

const galleryImages = [
  "/images/home/show4.png",
  "/images/home/show7.png",
  "/images/home/show3.png",
  "/images/home/show1.png",
  "/images/home/show5.png",
  "/images/home/show6.png",
  "/images/home/show2.png",
];

const LandingPage = () => {
  return (
    <main className="bg-white text-black">
      {/* Your existing headshot + quotes */}
      <section className="max-w-5xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <img
            src="/images/headshot.png"
            alt="Headshot"
            className="w-full h-auto object-cover"
          />
          <div className="space-y-6">
            <blockquote className="text-3xl font-italic font-fairplay">
	      Live Performance + Cultural Work
            </blockquote>
            <blockquote className="text-xl">
	      “Skillfully staged by Melory Mirashrafi, who also directed the Speakeasy production of English, the performance moves at a crisp pace.” - The Arts Fuse
            </blockquote>
            <blockquote>
	      “English is directed at SpeakEasy Stage Company with a sure hand by Melory Mirashrafi, who, like Toossi, is Iranian-American. Mirashrafi draws fine-tuned performances from the cast that land with the impact of emotional truth while not upending the play’s subtle, small-scale craftsmanship.” -Boston Globe
            </blockquote>
            <blockquote className="text-xl">
	      “To say that Artists Repertory Theatre is presenting Sapience in its new lobby doesn’t begin to describe the wondrous experience of stepping into the world of color, light and sound that director Melory Mirashrafi and her luminous cast and crew have created for this world premiere of Diana Burbano’s play.” - Oregon ArtsWatch
            </blockquote>
          </div>
        </div>
      </section>

      {/* Rotating gallery beneath */}
      <RotatingGallery
        images={galleryImages}
        intervalMs={4500}
        transitionMs={800}
        heightClass="h-[clamp(320px,40vw,680px)]"// tweak height as you like
      />
    </main>
  );
};

export default LandingPage;

